import {BaseFormModel} from './base-form-model';
import {Sortable} from './sortable';
import {MenuItem} from './menu-item';

export class MenuCategoryItem extends BaseFormModel<MenuItem> implements Sortable {
    id: number;
    name: string;
    sortOrder: number;
    menuItem: MenuItem;

    init(): void {
        this.menuItem = new MenuItem(this.menuItem);
    }
}
